/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.modals.removeEvent.controllers', [])

.controller('OrdersRequestsModalsRemoveEventController', ['$scope', '$uibModalInstance', 'SelectedEvents', 'IsTemplate', function($scope, $uibModalInstance, SelectedEvents, IsTemplate) {

    $scope.ordersRequestsModalsRemoveEvent = {

      selectedEvents: [],

      init: function() {
        this.selectedEvents = SelectedEvents;
      },

      done: function() {
        $uibModalInstance.close(this.selectedEvents);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      }

    };

    $scope.ordersRequestsModalsRemoveEvent.init();

}]);